import React from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import OAWorkflowTaskList from "./OAWorkflowTaskList";
import OAWorkflowIntakeUpload from "./OAWorkflowIntakeUpload";
import OAWorkflowImportBatchList from "./OAWorkflowImportBatchList";
import OAWorkflowTaskDetail from "./OAWorkflowTaskDetail";
import PGSTaskList from "./PGSTaskList";

import { axios_tenant } from "../../../../axios";

/**
 * Top-level container for OA Workflow in Collaboration Space.
 * Handles sub-routing and 403 redirect for all internal workflow pages.
 */
const OAWorkflow = () => {
    const navigate = useNavigate();

    // Common 403 redirect logic: if any workflow API returns 403, go to dashboard
    useEffect(() => {
        const interceptorId = axios_tenant.interceptors.response.use(
            (response) => response,
            (error) => {
                if (
                    error?.response?.status === 403 &&
                    error?.config?.url?.includes("/collaboration/workflow") &&
                    !error?.config?.ignore403
                ) {
                    navigate("/dashboard", { replace: true });
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios_tenant.interceptors.response.eject(interceptorId);
        };
    }, [navigate]);

    return (
        <Routes>
            <Route index element={<Navigate to="tasks" replace />} />
            <Route path="tasks" element={<OAWorkflowTaskList defaultTab={0} />} />
            <Route path="tasks/:taskId" element={<OAWorkflowTaskDetail />} />
            <Route path="intake" element={<OAWorkflowIntakeUpload />} />
            <Route path="batches" element={<OAWorkflowImportBatchList />} />

            <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
    );
};

export default OAWorkflow;
